class SmoothScroll {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    jQuery(function($){
      // #で始まるアンカーをクリックした場合に処理
      $('a[href^="#"]').click(function(){
        // 移動先を50px上にずらす
        if(isMobile()){
          var adjust = 100;
        }else{
          var adjust = 150;
        }
        // スクロールの速度
        var speed = 400; // ミリ秒
        // アンカーの値取得
        var href= $(this).attr("href");
        // 移動先を取得
        var target = $(href == "#" || href == "" ? 'html' : href);
        // 移動先を調整
        var position = target.offset().top - adjust;
        // スムーススクロール
        $('body,html').animate({scrollTop:position}, speed, 'swing');
        return false;
      });
    });
  }
}